import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useUserTheme } from "../hooks/useUserTheme";

interface ModalWrapperProps {
  title?: string;
  onClose?: () => void;
  children: React.ReactNode;
  showCloseButton?: boolean;
  showBackButton?: boolean;
  onBack?: () => void;
  width?: string; // e.g. max-w-xl, max-w-2xl
  className?: string; // extra custom styles
  positionClass?: string;
  disableClose?: boolean;
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({
  title,
  onClose,
  children,
  showCloseButton = true,
  showBackButton = false,
  onBack,
  width = "max-w-2xl",
  className = "",
  positionClass = "inset-0",
  disableClose = false,
}) => {
  const { bgClass, fontClass} = useUserTheme();

  const handleClose = () => {
    if (!disableClose && onClose) onClose();
  };

  const handleBack = () => {
    if (!disableClose && onBack) onBack();
  };

  return (
    <div className={`fixed ${positionClass} bg-black bg-opacity-50 flex items-center justify-center z-50 backdrop-blur-sm p-4`}>
      <div className={`rounded-lg w-full ${width} max-h-[90vh] flex flex-col bg-white rounded-xl ${className}`}>
        {/* Header (only show if title or close button is provided) */}
        {(title || showCloseButton || showBackButton) && (
          <div className={`p-3 border-b border-gray-200 relative flex items-center justify-between rounded-t-xl ${bgClass} ${fontClass}`}>
            {showBackButton && (
              <button 
                className={` ${fontClass} ${disableClose ? 'opacity-50 cursor-not-allowed' : ''}`} 
                onClick={handleBack}
                disabled={disableClose}
              >
                <ArrowBackIcon />
              </button>
            )}
            {title && <h2 className={`ml-2 text-2xl ${fontClass}`}>{title}</h2>}
            {showCloseButton && (
              <button 
                className={`ml-auto text-3xl ${fontClass} ${disableClose ? 'opacity-50 cursor-not-allowed' : ''}`} 
                onClick={handleClose}
                disabled={disableClose}
              >
                ×
              </button>
            )}
          </div>
        )}
        <div className="p-4 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
};